/** @format */
import { MarketCode } from '@mpb-com/feather/enums';

export const intercomProductConditionHelpUrls: Partial<
    Record<MarketCode, string>
> = {
    [MarketCode.EN_UK]:
        'https://intercom.help/mpbcom/en/articles/11383506-product-listings-and-condition-gradings-at-mpb',
    [MarketCode.FR_FR]:
        'https://fr.help.mpb.com/fr/articles/13770595-annonces-de-produit-et-evaluations-de-condition-chez-mpb',
    [MarketCode.DE_DE]:
        'https://de.help.mpb.com/de/articles/13726500-produktlistungen-bei-mpb-und-bewertung-des-optischen-zustands',
    [MarketCode.EN_EU]:
        'https://intercom.help/mpbcom-eu/en/articles/11394661-product-listings-and-condition-gradings-at-mpb',
    [MarketCode.EN_US]:
        'https://intercom.help/mpbcom-us/en/articles/11380750-product-information-and-condition-grading',
    [MarketCode.NL_NL]:
        'https://intercom.help/mpbcom-nl/nl/articles/5966634-welke-uiterlijke-conditie-moet-ik-kiezen',
    [MarketCode.IT_IT]:
        'https://intercom.help/mpbcom-IT/it/articles/11394661-elenchi-di-prodotti-e-valutazioni-delle-condizioni-su-mpb',
    [MarketCode.PT_PT]:
        'https://pt.help.mpb.com/pt/articles/11394661-listagens-de-produtos-e-classificacoes-de-condicao-na-mpb',
    [MarketCode.ES_ES]:
        'https://es.help.mpb.com/es/articles/11394661-listados-de-productos-y-clasificaciones-de-condicion-en-mpb',
    [MarketCode.DE_AT]:
        'https://de.help.mpb.com/de/articles/13726500-produktlistungen-bei-mpb-und-bewertung-des-optischen-zustands',
    [MarketCode.NL_BE]:
        'https://intercom.help/mpbcom-nl/nl/articles/5966634-welke-uiterlijke-conditie-moet-ik-kiezen',
    [MarketCode.FR_BE]:
        'https://fr.help.mpb.com/fr/articles/13770595-annonces-de-produit-et-evaluations-de-condition-chez-mpb',
    [MarketCode.EN_IE]:
        'https://intercom.help/mpbcom-eu/en/articles/11394661-product-listings-and-condition-gradings-at-mpb',
};

export const intercomProductConditionHelpUrlsConsolidatedHC: Partial<
    Record<MarketCode, string>
> = {
    [MarketCode.EN_UK]:
        'https://help.mpb.com/en-gb/articles/852129-product-listings-and-condition-gradings-at-mpb',
    [MarketCode.FR_FR]:
        'https://help.mpb.com/fr/articles/852129-annonces-de-produit-et-evaluations-de-condition-chez-mpb',
    [MarketCode.DE_DE]:
        'https://help.mpb.com/de/articles/852129-produktlistungen-bei-mpb-und-bewertung-des-optischen-zustands',
    [MarketCode.EN_EU]:
        'https://help.mpb.com/en/articles/852129-product-listings-and-condition-gradings-at-mpb',
    [MarketCode.EN_US]:
        'https://help.mpb.com/en-us/articles/852129-product-listings-and-condition-grading',
    [MarketCode.NL_NL]:
        'https://help.mpb.com/nl/articles/852129-productvermeldingen-en-conditiebeoordelingen-bij-mpb',
    [MarketCode.IT_IT]:
        'https://help.mpb.com/it/articles/852129-elenchi-di-prodotti-e-valutazioni-delle-condizioni-su-mpb',
    [MarketCode.PT_PT]:
        'https://help.mpb.com/pt/articles/852129-listagens-de-produtos-e-condicoes-cosmeticas-na-mpb',
    [MarketCode.ES_ES]:
        'https://help.mpb.com/es/articles/852129-listados-de-productos-y-clasificaciones-de-condicion-en-mpb',
    [MarketCode.DE_AT]:
        'https://help.mpb.com/de/articles/852129-produktlistungen-bei-mpb-und-bewertung-des-optischen-zustands',
    [MarketCode.NL_BE]:
        'https://help.mpb.com/nl/articles/852129-productvermeldingen-en-conditiebeoordelingen-bij-mpb',
    [MarketCode.FR_BE]:
        'https://help.mpb.com/fr/articles/852129-annonces-de-produit-et-evaluations-de-condition-chez-mpb',
    [MarketCode.EN_IE]:
        'https://help.mpb.com/en/articles/852129-product-listings-and-condition-gradings-at-mpb',
};
